import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useCart } from "../context/CartContext";
import { cents } from "../lib/api";
import { track } from "../lib/analytics";
import { BottleImg } from "./BottleImg";

const ACCENTS = {
  "tropical-recovery": "#C9563E", "hydrate-plus": "#257A8E", "electric-sun": "#D99B26",
  "flow-plus": "#8E3A4D", "citrus-drive": "#E0872E", "renew-plus": "#506B36",
};

export const AddinBadge = ({ addition, slug }) => addition ? (
  <span data-testid={`product-addin-badge-${slug}`} className="inline-block text-[11px] font-mono uppercase tracking-wider px-2 py-1 border"
    style={{ color: ACCENTS[slug] || "#A35847", borderColor: `${ACCENTS[slug] || "#A35847"}55`, background: `${ACCENTS[slug] || "#A35847"}0d` }}>
    + {addition}
  </span>
) : (
  <span data-testid={`product-addin-badge-${slug}`} className="inline-block text-[11px] font-mono uppercase tracking-wider px-2 py-1 border border-[#EBD9D0] text-[#171715]/60">
    fruit &amp; vegetable blend
  </span>
);

export const ProductCard = ({ p }) => {
  const { add, count, setDrawerOpen } = useCart();
  return (
    <article data-testid={`product-card-${p.slug}`} className="card-paper flex flex-col overflow-hidden group">
      <Link to={`/products/${p.slug}`} data-testid={`product-card-link-${p.slug}`} className="block photo-panel p-5 flex justify-center">
        <BottleImg src={p.image} alt={p.image_alt} width="210" height="280" sizes="(max-width: 640px) 70vw, 280px"
          className="h-64 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]" />
      </Link>
      <div className="p-4 flex flex-col gap-2 flex-1">
        <div className="flex items-baseline justify-between gap-2">
          <h3 className="text-lg font-display">{p.name}</h3>
          <span className="font-mono text-sm">{cents(p.price_cents)}</span>
        </div>
        <p className="text-xs text-[#171715]/60">12 fl oz / 355 mL</p>
        <p className="text-sm text-[#171715]/80 capitalize">{p.ingredients.join(", ")}</p>
        <AddinBadge addition={p.functional_addition} slug={p.slug} />
        <p className="text-xs text-[#171715]/55">{p.available ? "Made fresh to order" : "Currently unavailable"}</p>
        <div className="mt-auto pt-2 flex gap-2">
          <button data-testid={`product-add-to-cart-button-${p.slug}`} className="btn-ink flex-1 text-sm" disabled={!p.available}
            onClick={() => { if (count >= 24) { toast.info("Max 24 bottles per order"); return; } add(p.slug); track("add_to_cart", { item: p.slug }); toast.success(`${p.name} added to your stack`); setDrawerOpen(true); }}>
            Add bottle
          </button>
          <Link to={`/products/${p.slug}`} data-testid={`product-details-link-${p.slug}`} className="btn-ghost text-sm px-3">Details</Link>
        </div>
      </div>
    </article>
  );
};
